<template>
  <v-app>
    <v-app-bar height="80" style="max-height: 80px;">
      <v-app-bar-nav-icon v-if="mobile" @click="drawer = !drawer" class="mr-1"></v-app-bar-nav-icon>
      <v-container class="vxp-full-height py-0">
        <v-row class="vxp-full-height">
          <img
            :src="require('@/assets/cryo-topbar.png')"
            height="56"
            style="align-self: center;"
            :alt="siteTitle"
          >
          <h1 class="vxp-title pl-2" :class="mobile ? 'vxp-mobile-title' : ''">{{ title }}</h1>
          <v-spacer v-if="!mobile"/>
          <template v-if="!mobile">
            <v-tabs
              v-model="tab"
              ref="tabs"
              :color="color.primary.hex || 'grey'"
              class="vxp-top-menu vxp-menu-align"
            >
              <v-tab
                v-for="(item, index) in items"
                :ref="`tab${index}`"
                :key="index"
              >
                {{ item.tab }}
              </v-tab>
            </v-tabs>
          </template>
          <v-btn
            v-if="loggedIn && !mobile"
            @click="newPageDialog = true"
            small
            depressed
            dark
            :text="!mobile"
            color="pink"
            class="align-self-center ml-1"
          >
            Uusi
            <v-icon v-if="!mobile" class="ml-1">mdi-plus-circle</v-icon>
          </v-btn>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-sheet :class="loggedIn ? 'pb-10' : ''" :style="cssVars">
      <v-img
        v-if="!items || (items && items[tab].showBanner)"
        :height="mobileHero ? '450' : '400'"
        width="100vw"
        gradient="to top right, rgba(100,100,100,.43), rgba(25,25,25,0.2)"
        class="mb-10 grey lighten-2"
        :src="mobileHeroImage ? hero.mobileHeroImage : hero.heroImage"
      >
        <v-container class="vxp-full-height">
          <v-row
            class="vxp-full-height"
            :class="mobileHero ? 'justify-center mobile-hero-parent' : 'justify-left'"
            align="center"
          >
            <img
              :src="mobileHero
                ? require('@/assets/cryo-hero-mobile.png') : require('@/assets/cryo-hero.png')"
              :alt="siteTitle"
            >
            <div class="vxp-hero-text-block">
              <p
                class="vxp-hero-text vxp-mobile-hero"
                v-html="hero.heroText || 'Ladataan<br>Odota hetki...'"
                style="min-width: 254px;"
              />
              <v-btn
                :block="mobileHero"
                :class="`${mobileHero ? 'mb-2' : ''} ${!!items ? 'elevation-12' : ''}`"
                :href="hero.heroButtonLink"
                dark
                x-large
                tile
                :depressed="!items"
                :loading="!items"
                :color="color.primary.hex || 'grey lighten-2'"
                class="mt-4"
              >
                {{ hero.heroButtonText }}
              </v-btn>
            </div>
          </v-row>
        </v-container>

        <v-btn
          v-show="loggedIn"
          class="mt-6"
          color="pink"
          fab
          dark
          x-small
          absolute
          top
          right
          @click="showHeroSelectionDialog('desktop')"
        >
          <v-icon>mdi-image</v-icon>
        </v-btn>
        <v-btn
          v-show="loggedIn"
          class="mt-16"
          color="pink"
          fab
          dark
          x-small
          absolute
          top
          right
          @click="showHeroSelectionDialog('mobile')"
        >
          <v-icon>mdi-cellphone</v-icon>
        </v-btn>
      </v-img>
      <v-container>
        <v-row>
          <v-col
            :lg="items && items[tab].showNews ? '8' : '12'"
            :class="mobile ? 'pl-6' : 'pr-16'"
          >
            <v-dialog v-if="items && items.length" v-model="items[tab].edit" width="500">
              <v-card>
                <v-card-title>
                  Sivun asetukset
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="items[tab].tab"
                    color="pink"
                    label="Sivun nimi valikossa"
                    hide-details
                    outlined
                  />
                  <v-text-field
                    v-model="items[tab].metaDescription"
                    color="pink"
                    label="Sivun selite hakukoneita varten"
                    hide-details
                    class="mt-2"
                    outlined
                  />
                  <v-checkbox
                    v-model="items[tab].showNews"
                    color="pink"
                    label="Näytä ajankohtaista"
                  />
                  <v-checkbox
                    v-model="items[tab].showGallery"
                    color="pink"
                    label="Näytä galleria"
                  />
                  <v-checkbox
                    v-model="items[tab].columns"
                    color="pink"
                    label="Kaksi palstaa"
                  />
                  <v-checkbox
                    v-model="items[tab].showBanner"
                    color="pink"
                    label="Näytä banneri"
                  />
                  <label>Siirrä valikossa</label><br>
                  <v-btn text color="pink" @click="movePrevious()">Vasemmalle</v-btn>
                  <v-btn text color="pink" @click="moveNext()">Oikealle</v-btn>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    :disabled="!items[tab].tab"
                    :color="color.primary.hex"
                    dark
                    @click="items[tab].edit = false;"
                  >
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card flat>
              <v-alert
                v-if="loggedIn && items && items.length"
                text
                border="left"
                color="grey lighten-2"
                dense
              >
                <v-btn
                  class="mr-0 mb-1"
                  :text="!mobileHero"
                  :dark="mobileHero"
                  :block="mobileHero"
                  :small="!mobileHero"
                  color="pink"
                  @click="items[tab].edit = !items[tab].edit"
                >
                  Sivu
                  <v-icon class="ml-1">mdi-cog</v-icon>
                </v-btn>
                <v-btn
                  :text="!mobileHero"
                  :dark="mobileHero"
                  :block="mobileHero"
                  :small="!mobileHero"
                  color="pink"
                  class="mr-0 mb-1"
                  @click="gallerySelection(items[tab])"
                >
                  Kuvat
                  <v-icon class="ml-1">mdi-image</v-icon>
                </v-btn>
                <v-btn
                  :text="!mobileHero"
                  :dark="mobileHero"
                  :block="mobileHero"
                  :small="!mobileHero"
                  class="mr-0 mb-1"
                  color="pink"
                  @click="addSection()"
                >
                  Uusi osio
                  <v-icon class="ml-1">mdi-plus-circle</v-icon>
                </v-btn>
                <v-btn
                  :text="!mobileHero"
                  :dark="mobileHero"
                  :block="mobileHero"
                  :small="!mobileHero"
                  class="mr-0 mb-1"
                  color="pink"
                  @click="deletePageDialog = true"
                >
                  Poista sivu
                  <v-icon class="ml-1">mdi-delete</v-icon>
                </v-btn>
              </v-alert>
              <v-row>
                <template v-if="items && items.length">
                    <template
                      v-for="(item, idx) in items[tab].content"
                    >
                      <v-col :key="idx" cols="12" :md="items[tab].columns ? '6' : '12'">
                        <v-card-text
                          v-if="item.md"
                          :key="`${idx}-md`"
                          v-html="c(item.md)"
                          style="white-space: pre-wrap;"
                          class="pt-4 pb-10 site-content"
                        />
                        <div
                          v-if="item.embed"
                          :key="`${idx}-embed`"
                          v-html="item.embed"
                        />
                        <v-card-text
                          v-if="item.linkText"
                          :key="`${idx}-link`"
                          class="pt-0 pb-8"
                        >
                          <v-btn
                            dark
                            x-large
                            tile
                            :color="color.primary.hex"
                            class="elevation-12"
                            :href="item.linkAddress"
                          >
                            {{ item.linkText }}
                          </v-btn>
                        </v-card-text>
                        <v-alert v-if="loggedIn" text border="left" color="grey lighten-2" dense>
                          <v-btn
                            text
                            color="pink"
                            class="mr-1"
                            small
                            @click="editItem(item)"
                          >
                            Muokkaa
                            <v-icon class="ml-1">mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            text
                            color="pink"
                            class="mr-1"
                            small
                            @click="showRemoveDialog(item)"
                          >
                            Poista osio
                            <v-icon class="ml-1">mdi-delete</v-icon>
                          </v-btn>
                        </v-alert>
                      </v-col>
                  </template>
                </template>
              </v-row>
              <v-card-text
                v-if="items
                && items.length
                &&items[tab].showGallery
                && items[tab].gallery
                && items[tab].gallery.length"
              >
                <v-row>
                  <v-col
                    v-for="(item, index) in items[tab].gallery"
                    :key="index"
                    class="d-flex child-flex"
                    md="4"
                    cols="6"
                  >
                    <v-img
                      :src="item.image"
                      :alt="item.caption"
                      aspect-ratio="1"
                      class="grey lighten-2"
                      @click="showGalleryDialog(item)"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-row>

                <v-dialog v-model="galleryDialog" fullscreen>
                  <v-card>
                    <v-carousel
                      height="90vh"
                      v-model="carouselItem"
                      hide-delimiters
                      :show-arrows="items[tab].gallery.length > 1"
                    >
                      <v-carousel-item
                        v-for="(item, index) in items[tab].gallery"
                        :key="index"
                      >
                        <v-img
                          eager
                          contain
                          height="80%"
                          :src="item.image"
                        />
                        <v-text-field
                          v-if="loggedIn"
                          v-model="item.caption"
                          outlined
                          hide-details
                          light
                          color="pink"
                          dense
                          class="my-2 mx-4"
                          label="Selite"
                        />
                        <p v-else class="black--text mx-7 mt-2">{{ item.caption }}</p>
                      </v-carousel-item>
                    </v-carousel>
                    <v-btn
                      class="mt-8"
                      :color="color.primary.hex"
                      fab
                      dark
                      small
                      absolute
                      top
                      right
                      @click="galleryDialog = false;"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card>
                </v-dialog>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            v-if="items && items.length && items[tab].showNews"
            cols="12"
            lg="4"
            class="pt-16"
          >
            <div>
              <p class="vxp-news mt-4 mb-1">Ajankohtaista</p>
              <v-card
                v-for="(newsItem, idx) in showingNews"
                :key="idx"
                flat
                class="mb-0 pl-0"
              >
                <!-- <v-divider v-if="idx > 0" class="ml-6 mr-16"/> -->
                <v-card-title class="pb-3 pl-7 vxp-news-title">
                  {{ newsItem.title }}
                </v-card-title>
                <v-card-subtitle class="caption pb-2 pl-7">
                  {{ newsItem.date }}
                </v-card-subtitle>
                <v-card-text class="pl-7 pb-3 pt-0" style="white-space: pre-wrap">
                  {{ newsItem.description }}
                </v-card-text>
                <v-card-actions v-if="loggedIn">
                  <v-spacer/>
                  <v-btn
                    small
                    text
                    color="pink"
                    class="ml-7"
                    @click="removeNewsItem(newsItem)"
                  >
                    Poista
                    <v-icon class="ml-1">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-btn
                v-if="offset <= showingNews.length"
                :color="color.primary.hex"
                class="ml-7 mt-4"
                small
                dark
                outlined
                @click="offset += 5"
              >
                Näytä lisää
              </v-btn>
              <div v-if="loggedIn" class="pa-0 mt-4 ml-7">
                <h2 class="vxp-news-title mb-1">Lisää uutinen</h2>
                <v-text-field
                  v-model="newsItemTitle"
                  outlined
                  hide-details
                  color="pink"
                  dense
                  class="mb-2"
                  label="Otsikko"
                />
                <v-text-field
                  v-model="newsItemDate"
                  outlined
                  color="pink"
                  hide-details
                  dense
                  class="mb-2"
                  label="Päivämäärä"
                />
                <v-textarea
                  v-model="newsItem"
                  outlined
                  color="pink"
                  hide-details
                  class="mb-2"
                  label="Teksti"
                />
                <v-row>
                  <v-spacer/>
                  <v-btn
                    text
                    color="pink"
                    class="mr-1 mb-1"
                    small
                    :disabled="!newsItem || !newsItemDate || !newsItemTitle"
                    @click="addNews()"
                  >
                    Lisää
                    <v-icon class="ml-1">mdi-plus-circle</v-icon>
                  </v-btn>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="itemEdit" fullscreen>
        <v-card>
          <v-container>
            <v-card-title>Osion sisältö</v-card-title>
            <v-card-text>
              <v-textarea
                v-model="currentEditedItem.md"
                outlined
                auto-grow
                color="pink"
                label="Sisältö"
              />
              <v-text-field
                v-model="currentEditedItem.embed"
                color="pink"
                label="Upotuskoodi"
                outlined
              />
              <v-text-field
                v-model="currentEditedItem.linkText"
                color="pink"
                label="Painikkeen teksti"
                outlined
              />
              <v-text-field
                v-model="currentEditedItem.linkAddress"
                color="pink"
                label="Painikkeen linkki"
                outlined
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                depressed
                class="mr-1 mb-1"
                @click="itemEdit = false;"
              >
                Peruuta
              </v-btn>
              <v-btn
                depressed
                class="mr-1 mb-1"
                :color="color.primary.hex"
                dark
                @click="updateItem()"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="uploadImagesDialog"
        width="500"
      >
        <upload-image/>
      </v-dialog>
      <v-dialog
        v-if="items && items.length"
        v-model="showGallerySelection"
        width="800"
      >
        <v-card>
          <v-card-title>
            Valitse kuvat sivun galleriaan
          </v-card-title>
          <v-card-text class="grey lighten-2 pa-4">
            <v-row>
              <v-col
                v-for="(item, index) in selectableImages"
                :key="index"
                cols="12"
                md="4"
              >
                <v-img
                  :src="item"
                  aspect-ratio="1"
                  :class="items[tab].gallery
                    && items[tab].gallery.some((i) => i.image === item) ? '' : 'ma-6'"
                  @click="addToGallery(item)"
                >
                  <v-btn
                    v-if="items[tab].gallery
                      && items[tab].gallery.some((i) => i.image === item)"
                    class="mx-2"
                    fab
                    dark
                    small
                    color="green"
                  >
                    <v-icon dark>
                      mdi-check
                    </v-icon>
                  </v-btn>
                </v-img>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              :color="color.primary.hex"
              dark
              depressed
              @click="showGallerySelection = false"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="items && items.length"
        v-model="showHeroSelection"
        width="800"
      >
        <v-card>
          <v-card-title>
            Valitse taustakuva {{ mobileHeroSelection ? '(mobiili)' : '' }}
          </v-card-title>
          <v-card-text class="grey lighten-2 pa-4">
            <v-row>
              <v-col
                v-for="(item, index) in selectableImages"
                :key="index"
                cols="12"
                md="4"
              >
                <v-img
                  v-if="mobileHeroSelection"
                  :src="item"
                  aspect-ratio="1"
                  @click="hero.mobileHeroImage = item; showHeroSelection = false;"
                />
                <v-img
                  v-else
                  :src="item"
                  aspect-ratio="1"
                  @click="hero.heroImage = item; showHeroSelection = false;"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loginDialog"
        width="500"
      >
        <v-btn @click="openLogin()">Kirjaudu</v-btn>
      </v-dialog>
      <v-dialog
        v-model="removeDialog"
        width="500"
      >
        <v-card>
          <v-card-title>Poista osio</v-card-title>
          <v-card-text>Oletko varma että haluat poistaa osion?</v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="removeDialog = false;" depressed>Peruuta</v-btn>
            <v-btn
              @click="removeSection(itemToBeRemoved)"
              depressed
              dark
              :color="color.primary.hex"
            >
              Poista
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="settingsDialog"
        width="500"
      >
        <v-card>
          <v-card-title>Asetukset</v-card-title>
          <v-card-text>
            <legend>Teemaväri</legend>
            <v-color-picker
              v-if="color"
              v-model="color.primary.hex"
              mode="hexa"
              hide-mode-switch
            />
            <v-text-field
              v-model="hero.heroText"
              color="pink"
              class="mb-4"
              label="Bannerin teksti"
              hide-details
              outlined
            />
            <v-text-field
              v-model="hero.heroButtonText"
              color="pink"
              label="Bannerin painikkeen teksti"
              class="mb-4"
              hide-details
              outlined
            />
            <v-text-field
              v-model="hero.heroButtonLink"
              color="pink"
              label="Bannerin painikkeen linkki"
              hide-details
              outlined
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              @click="settingsDialog = false;"
              dark depressed
              :color="color.primary.hex"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="newPageDialog"
        width="500"
      >
        <v-card>
          <v-card-title>Uusi sivu</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="newPageTitle"
              color="pink"
              class="mb-4"
              label="Sivun otsikko"
              hide-details
              outlined
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="newPageDialog = false;" depressed>Peruuta</v-btn>
            <v-btn
              :disabled="!newPageTitle"
              dark
              :color="color.primary.hex"
              @click="newPage()" depressed
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deletePageDialog"
        width="500"
      >
        <v-card>
          <v-card-title>Poista sivu</v-card-title>
          <v-card-text>
            Oletko varma että haluat poistaa sivun?
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="deletePageDialog = false;" depressed>Peruuta</v-btn>
            <v-btn @click="deletePage()" :color="color.primary.hex" dark depressed>Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="saveDialog"
        width="500"
      >
        <v-card>
          <v-card-title>Tallennetaanko muutokset?</v-card-title>
          <v-card-text>
            Tallennetaanko muutokset palvelimelle? Voit tehdä tämän myös myöhemmin.
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="saveDialog = false;" depressed>Ei</v-btn>
            <v-btn
              @click="save();saveDialog = false;"
              :color="color.primary.hex"
              dark
              depressed
            >
              Kyllä
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list
        nav
      >
        <v-list-item-group
          v-model="tab"
        >
          <v-list-item
            v-for="(item, idx) in items"
            :key="idx"
            @click="switchPage(item);drawer = false;"
            link
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.tab }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="loggedIn" color="pink" @click="newPageDialog = true">
            <v-list-item-content>
              <v-list-item-title><v-icon>mdi-plus-circle</v-icon> Uusi sivu</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-bottom-navigation v-if="loggedIn" fixed>
      <v-btn value="recent" @click="save()">
        <span>Julkaise</span>

        <v-icon color="pink">mdi-cloud-upload</v-icon>
      </v-btn>

      <v-btn value="recent" @click="settingsDialog = true">
        <span>Asetukset</span>

        <v-icon color="pink">mdi-cog</v-icon>
      </v-btn>

      <v-btn @click="uploadImagesDialog = true">
        <span>Lisää kuvia</span>

        <v-icon color="pink">mdi-image</v-icon>
      </v-btn>

      <v-btn @click="logout()">
        <span>Kirjaudu ulos</span>

        <v-icon color="pink">mdi-logout</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
import Vue from 'vue';
import showdown from 'showdown';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'App',

  components: {
    'upload-image': () => import('./components/UploadImage'),
  },

  metaInfo() {
    return {
      title: process.env.VUE_APP_TITLE,
      titleTemplate: `%s${this.page ? ` - ${this.page}` : ''}`,
      meta: [{
        name: 'description',
        content: this.metaDescription || this.page,
      }],
      htmlAttrs: {
        lang: 'fi',
      },
    };
  },

  data: () => ({
    itemEdit: false,
    currentEditedItem: {},
    currentEditedItemIndex: null,
    deletePageDialog: false,
    newsItem: '',
    newsItemTitle: '',
    newsItemDate: new Date().toLocaleDateString('fi'),
    bottomNavi: false,
    drawer: false,
    converter: new showdown.Converter(),
    tab: 0,
    edit: true,
    loginDialog: false,
    galleryDialog: false,
    uploadImagesDialog: false,
    saveDialog: false,
    newPageDialog: false,
    newPageTitle: '',
    showGallerySelection: false,
    showHeroSelection: false,
    mobileHeroSelection: false,
    removeDialog: false,
    settingsDialog: false,
    selectableImages: null,
    currentGallery: null,
    offset: 5,
    pageTitle: '',
    carouselItem: 0,
  }),
  computed: {
    ...mapState({
      color: (state) => state.content.color,
      items: (state) => state.content.content.items,
      gallery: (state) => state.content.content.gallery,
      title: (state) => state.content.title,
      news: (state) => state.content.news,
      hero: (state) => state.content.hero,
      loggedIn: (state) => state.user.loggedIn,
    }),
    metaDescription() {
      if (this.items && this.items.length) {
        return this.items[this.tab].metaDescription;
      }
      return '';
    },
    cssVars() {
      return {
        '--primary-vxp-color': this.color.primary.hex,
      };
    },
    siteTitle() {
      return process.env.VUE_APP_TITLE;
    },
    mobile() {
      return !this.$vuetify.breakpoint.lgAndUp;
    },
    mobileHero() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    mobileHeroImage() {
      return this.$vuetify.breakpoint.xs;
    },
    page() {
      return this.$route.params.page;
    },
    showingNews() {
      return this.news.slice(0, this.offset);
    },
  },
  methods: {
    ...mapActions('user', {
      login: 'login',
      logout: 'logout',
    }),
    ...mapActions('content', {
      read: 'read',
      save: 'save',
      listImages: 'listImages',
      setItems: 'setItems',
    }),
    switchPage(item) {
      this.$router.push(`/${item.tab}`);
    },
    editItem(item) {
      this.currentEditedItemIndex = this.items[this.tab].content.indexOf(item);
      this.currentEditedItem = { ...item };
      this.itemEdit = true;
    },
    updateItem() {
      this.items[this.tab].content[this.currentEditedItemIndex] = this.currentEditedItem;
      this.itemEdit = false;
      this.confirmation();
    },
    showGalleryDialog(item) {
      this.carouselItem = this.items[this.tab].gallery.indexOf(item);
      this.galleryDialog = true;
    },
    addToGallery(item) {
      if (!this.items[this.tab].gallery) {
        Vue.set(this.items[this.tab], 'gallery', []);
      }
      if (!this.items[this.tab].gallery.some((i) => i.image === item)) {
        const image = { image: item, caption: '' };
        this.items[this.tab].gallery.push(image);
      } else {
        const itemId = this.items[this.tab].gallery.indexOf(item);
        this.items[this.tab].gallery.splice(itemId, 1);
      }
    },
    openLogin() {
      this.login();
      this.loginDialog = false;
      this.tab = 0;
      this.$router.push(`/${this.items[0].tab}`);
    },
    async gallerySelection(item) {
      this.showGallerySelection = true;
      this.currentGallery = item.gallery || [];
      this.selectableImages = await this.listImages();
    },
    async showHeroSelectionDialog(type) {
      if (type === 'mobile') {
        this.mobileHeroSelection = true;
      } else {
        this.mobileHeroSelection = false;
      }
      this.showHeroSelection = true;
      this.selectableImages = await this.listImages();
    },
    c(text) {
      return this.converter.makeHtml(text);
    },
    confirmation() {
      this.saveDialog = true;
    },
    addNews() {
      this.news.push({
        date: this.newsItemDate,
        description: this.newsItem,
        title: this.newsItemTitle,
      });
      this.newsItem = '';
      this.newsItemDate = new Date().toLocaleDateString('fi');
      this.newsItemTitle = '';
    },
    deletePage() {
      const currentIndex = this.tab;
      this.tab = 0;
      this.items.splice(currentIndex, 1);
      this.confirmation();
      this.deletePageDialog = false;
    },
    newPage() {
      this.items.push({
        columns: false,
        edit: false,
        content: [],
        gallery: [],
        pageTitle: this.newPageTitle,
        showGallery: false,
        showNews: false,
        tab: this.newPageTitle,
      });
      this.newPageDialog = false;
    },
    addSection() {
      this.items[this.tab].content.push({
        edit: true,
        md: '',
        embed: '',
        linkText: '',
        linkAddress: '',
      });
      const itemIndex = this.items[this.tab].content.length - 1;
      this.editItem(this.items[this.tab].content[itemIndex]);
    },
    showRemoveDialog(item) {
      this.itemToBeRemoved = item;
      this.removeDialog = true;
    },
    removeSection(item) {
      const itemId = this.items[this.tab].content.indexOf(item);
      this.items[this.tab].content.splice(itemId, 1);
      this.removeDialog = false;
    },
    removeNewsItem(item) {
      const index = this.news.indexOf(item);
      this.news.splice(index, 1);
    },
    moveNext() {
      const itemId = this.tab;
      if (this.tab < (this.items.length - 1)) {
        this.move(this.items, itemId, (itemId + 1));
        this.tab += 1;
      }
    },
    movePrevious() {
      const itemId = this.tab;
      if (this.tab > 0) {
        this.move(this.items, itemId, (itemId - 1));
        this.tab -= 1;
      }
    },
    move(arr, old, newI) {
      let oldIndex = old;
      let newIndex = newI;
      while (oldIndex < 0) {
        oldIndex += arr.length;
      }
      while (newIndex < 0) {
        newIndex += arr.length;
      }
      if (newIndex >= arr.length) {
        let k = newIndex - arr.length;
        // eslint-disable-next-line no-plusplus
        while ((k--) + 1) {
          arr.push(undefined);
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
      this.setItems(arr);
    },
  },
  watch: {
    tab: {
      handler(val) {
        this.$router.push(`/${this.items[val].tab}`);
        this.items[val].pageTitle = this.items[val].tab;
      },
    },
  },
  async created() {
    if (this.$route.params.page === 'login') {
      this.loginDialog = true;
    }
    await this.read();
    if (!this.color) {
      this.color.primary = '#C5B358';
    }
    const currentItem = this.items.find((i) => i.tab === this.page);
    if (currentItem) {
      this.tab = this.items.indexOf(currentItem);
    }
    this.items[this.tab].pageTitle = this.items[this.tab].tab;
  },
  mounted() {
    if (!this.mobile && this.$refs.tab0) {
      const initial = this.$refs.tab0[0].$el.offsetWidth;
      const interval = setInterval(() => {
        if (this.$refs.tab0[0]) {
          if (this.$refs.tab0[0].$el.offsetWidth !== initial) {
            clearInterval(interval);
            this.$refs.tabs.callSlider();
          }
        }
      }, 250);
    }
  },
};
</script>
<style lang="scss">
  .v-application {
    font-family: 'Baloo 2', cursive !important;
  }

  .vxp-news-title {
    font-family: 'Dosis', sans-serif;
    color: rgba(0, 0, 0, 0.7);
  }

  .v-tab {
    font-family: 'Dosis', sans-serif;
    text-transform: none !important;
    font-size: 1rem !important;
  }

  h1.vxp-title {
    font-family: 'Dosis', sans-serif;
    font-size: 18px !important;
    align-self: center;
  }

  h1.vxp-title.vxp-mobile-title {
    font-size: 13px !important;
  }

  .vxp-primary {
    color: var(--primary-vxp-color) !important;
  }

  .vxp-hero-text {
    font-family: 'Dosis', sans-serif;
    font-size: 48px !important;
    line-height: 49px;
    border-left: 4px var(--primary-vxp-color) solid;
    padding-left: 24px;
    padding-bottom: 12px;
    padding-top: 6px;
    text-align: left;
    color: #FFF;
  }

  .vxp-news {
    font-family: 'Dosis', sans-serif;
    font-size: 30px !important;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.6);
    border-left: 4px var(--primary-vxp-color) solid;
    padding-left: 24px;
    padding-bottom: 12px;
    padding-top: 6px;
    text-align: left;
  }

  .vxp-top-menu {
    // align-self: flex-end;
    flex: none !important;
    width: auto !important;

    .v-item-group {
      background-color: transparent !important;
    }
  }

  .vxp-full-height {
    height: 100%;
  }

  .vxp-menu-align {
    align-self: center;
  }
  h1 {
    font-family: 'Dosis', sans-serif;
    // font-weight: 100;
    font-size: 2.2rem !important;
    line-height: 3rem;
  }

  .site-content h1 {
    padding-left: 24px;
    border-left: 4px var(--primary-vxp-color) solid !important;
    margin-left: -28px;
  }

  .site-content p {
    margin-bottom: 0 !important;
  }

  .mobile-hero-image {
    padding-left: 24px;
    padding-right: 24px;
  }

  .vxp-hero-text-block {
    margin-left: 40px;
  }

  .mobile-hero-parent {
    .vxp-hero-text-block {
      margin-left: 16px;
    }
    .vxp-mobile-hero {
      font-size: 30px !important;
      line-height: 34px;
    }

    .mobile-hero-image {
      width: 208px;
      padding-left: 0px;
      padding-right: 0px;
    }

  }
</style>
